import moment from "moment";

export default function formatFilterDate(date, format) {
  if (date === null) {
    return null;
  }

  return moment(date).format(format || "YYYY-MM-DD");
}
